(async function (global) {
  let azureBlobTokenKey;
  let configURL = window["__env"]["azureAccountUrl"] + "/config/assets/images/";
  let proxy = window["__env"]["proxy"];
  let backendApiUrl = window["__env"]["backendApiUrl"];
  let hostName = document.location.hostname;
  if (window["__env"]["backendApiUrl"] == "" || hostName.includes("express")) {
    backendApiUrl = window.location.protocol + "//" + hostName;
  }

  var counter = 0,
    timeout;
  var preloader = document.querySelector(".preloaderapp");
  var progressBar = document.querySelector(".preloaderapp-progress-bar");
  var body = document.querySelector("body");
  let pathData = location.pathname.split("/");
  let tenantId = "";
  let propertyId = "";
  let appName = "";
  let legacyApps = ["wbe", "spa", "golf", "cico"];
  let onecartApps = ["wbe", "spa", "golf", "seat", "unit", "giftcard", "activities", "snc"];

  if (legacyApps.includes(pathData[1])) {
    appName = pathData[1];
    tenantId = pathData[3];
    propertyId = pathData[4];
  } else if ("onecart" === pathData[1] && onecartApps.includes(pathData[2])) {
    appName = pathData[2] === "activities" ? "seat" : pathData[2];
    tenantId = pathData[4];
    propertyId = pathData[5];
  } else if ("onecart" === pathData[1]) {
    appName = "NA";
    tenantId = pathData[3];
    propertyId = pathData[4];
  }

  if (appName == "cico") {
    backendApiUrl = window["__env"]["expressBackendApiUrl"];
  }

  if (pathData[1] === "admin") {
    // disables scrollbar
    body.style.overflow = "hidden";

    timeout = setTimeout(startCounter, 20);

    // main.ts call this function once the app is boostrapped
    global.appBootstrap = function () {
      setTimeout(endCounter, 1000);
    };
    return;
  }

  let response;
  if (proxy) {
    let data = {
      url: `${backendApiUrl}/wbe-admin-service/generateAzureBlobStorageSAS`,
      method: "get",
    };
    response = await fetch("https://aks-wbe-dev.hospitalityrevolution.com/node/nodeapi", {
      method: "PUT",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(data),
    });
  } else {
    const browserUrl = window.location.protocol + "//" + hostName;
    let tkUrl = `${browserUrl}/wbe-admin-service/generateAzureBlobStorageSAS`;
    response = await fetch(tkUrl, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    });
  }
  const resData = await response.json();
  if (resData && resData.success) {
    azureBlobTokenKey = resData.token;
    window.__env.azureBlobTokenKey = resData.token;
  }

  if (appName === "onecart") {
    await getTheming();
  }

  // Start Link Fav Icon
  let favIcon = azureTokenAdd(`${configURL}${tenantId}-${propertyId}/favicon.ico`);
  setFavIcon(favIcon);

  if (appName === "onecart") {
    var image = new Image();
    image.onerror = function () {
      favIcon = "favicon.ico";
      setFavIcon(favIcon);
    };
    image.src = azureTokenAdd(`${configURL}${tenantId}-${propertyId}/favicon.ico`);
  }
  // End Link Fav Icon

  let preload1 = "";
  let preload2 = "";
  if (appName != "NA") {
    preload1 = azureTokenAdd(`${configURL}${tenantId}-${propertyId}/preloader/empty.${appName}.png`);
    preload2 = azureTokenAdd(`${configURL}${tenantId}-${propertyId}/preloader/full.${appName}.png`);
  } else {
    preload1 = azureTokenAdd(`${configURL}${tenantId}-${propertyId}/preloader/empty.png`);
    preload2 = azureTokenAdd(`${configURL}${tenantId}-${propertyId}/preloader/full.png`);
  }

  if (pathData[1] === "admin") {
    document.querySelector(".preloaderapp-progress").style.backgroundImage = `url('assets/admin/img/loading-gray.png')`;
    document.querySelector(".preloaderapp-progress-bar").style.backgroundImage = `url('assets/admin/img/loading.png')`;
  } else {
    document.querySelector(".preloaderapp-progress").style.backgroundImage = `url('${preload1}')`;
    document.querySelector(".preloaderapp-progress-bar").style.backgroundImage = `url('${preload2}')`;
  }

  function setFavIcon(favIconSrc) {
    let link = document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = favIconSrc;
    document.getElementsByTagName("head")[0].appendChild(link);
  }

  if (!preloader) {
    return;
  }

  body.style.overflow = "hidden";

  timeout = setTimeout(startCounter, 20);

  global.appBootstrap = function () {
    setTimeout(endCounter, 1000);
  };

  function startCounter() {
    var remaining = 100 - counter;
    counter = counter + 0.015 * Math.pow(1 - Math.sqrt(remaining), 2);

    if (progressBar) progressBar.style.width = Math.round(counter) + "%";

    timeout = setTimeout(startCounter, 20);
  }

  function azureTokenAdd(imgUrl) {
    let imagePath = "";
    imagePath = imgUrl;
    if (imagePath && azureBlobTokenKey) {
      let arr = imagePath.split("?");
      if (arr.length > 1) {
        imagePath = imagePath + "&" + azureBlobTokenKey;
      } else {
        imagePath = imagePath + "?" + azureBlobTokenKey;
      }
    }
    return imagePath;
  }

  function endCounter() {
    clearTimeout(timeout);

    if (progressBar) {
      progressBar.style.width = "100%";
    }
    setTimeout(function () {
      // animate preloader hiding
      removePreloader();
      // retore scrollbar
      if (pathData[1] !== "cico") {
        body.style.overflow = "";
      }
    }, 300);
  }

  function removePreloader() {
    preloader.addEventListener("transitionend", function () {
      preloader.className = "preloaderapp-hidden";
    });
  }

  async function getTheming() {
    let resp;
    let theme = azureTokenAdd(
      `${window["__env"]["azureAccountUrl"]}/onecart/${tenantId}/${propertyId}/styles/${tenantId}-${propertyId}-onecart.css`
    );
    let tkUrl = `${theme}`;
    resp = await fetch(tkUrl, {
      method: "GET",
      headers: {
        "Content-type": "application/text",
      },
    });
    const respData = await resp.text();
    if (!respData.includes("</Error>")) {
      try {
        console.log(respData.length);
        window.__env.themeCSS = respData;
        const str = respData.toString();
        const themeLoader = str.substring(str.indexOf("/* --> App Preloader starts */"), str.lastIndexOf("/* --> App Preloader ends */"));
        console.log(themeLoader);
        if (themeLoader && themeLoader.length > 0) injectStylesheet(themeLoader, "appthemeheader");
      } catch (error) {
        console.log(error);
      }
    }
  }

  function injectStylesheet(css, id) {
    const head = document.head || document.getElementsByTagName("head")[0];
    this.styleTag = document.createElement("style");
    this.styleTag.type = "text/css";
    this.styleTag.id = id;
    this.styleTag.textContent = css;
    head.appendChild(this.styleTag);
    console.log("Injected Theme");
  }
})(window);
